export default __webpack_public_path__ + "static/media/i_bus-jeonse_pp.74b92346.svg";